import { Link } from "react-router-dom";
import { qtyDisplay } from "@icraftx/shared/v1";
import { PendingStatus } from "@/components/ui/pending-indicator";
import type { DeskGlanceTopLowStock } from "@/shared/api/desk";
import { HomeMetricCard } from "./HomeMetricCard";

const COMPACT_N = 3;

function RankList(props: {
  rows: DeskGlanceTopLowStock[];
  companySlug: string;
  limit: number;
}) {
  return (
    <ol className="m-0 list-none space-y-2 p-0">
      {props.rows.slice(0, props.limit).map((row, i) => (
        <li key={row.productId}>
          <Link
            to={`/c/${props.companySlug}/products/${row.productId}`}
            className="grid grid-cols-[1.25rem_1fr_auto] items-baseline gap-2 no-underline"
          >
            <span className="text-xs tabular-nums text-[var(--color-muted)]">
              {i + 1}.
            </span>
            <span className="min-w-0 truncate text-sm font-medium text-[var(--color-foreground)]">
              {row.name}
            </span>
            <span className="text-xs tabular-nums text-[var(--color-muted)]">
              {qtyDisplay(row.onHand)}
              <span className="text-[var(--color-muted-fg)]">
                {" "}
                / ≤{qtyDisplay(row.threshold)}
              </span>
            </span>
          </Link>
        </li>
      ))}
    </ol>
  );
}

/** Compact Top low-stock → Show more — plan/50. */
export function TopLowStockWidget(props: {
  companySlug: string;
  rows: DeskGlanceTopLowStock[] | null | undefined;
  loading?: boolean;
  onCustomize?: () => void;
}) {
  const rows = props.rows ?? [];
  if (props.loading && !props.rows) {
    return (
      <HomeMetricCard
        title="Top low stock"
        description="On-hand at or below threshold"
        onCustomize={props.onCustomize}
        compact={<PendingStatus>Loading…</PendingStatus>}
        expanded={<PendingStatus>Loading…</PendingStatus>}
      />
    );
  }
  return (
    <HomeMetricCard
      title="Top low stock"
      description="On-hand at or below threshold"
      expandedDescription="Ranked by shortage (threshold − on hand). Tap a row for the product · Inventory Low stock for the full list."
      onCustomize={props.onCustomize}
      empty={rows.length === 0}
      emptyMessage="No stocked items at or below their low-stock threshold."
      actions={
        <Link
          to={`/c/${props.companySlug}/inventory?lowStock=1`}
          className="shrink-0 text-xs font-medium text-[var(--color-primary)] no-underline hover:underline"
        >
          Inventory
        </Link>
      }
      compact={
        <RankList
          rows={rows}
          companySlug={props.companySlug}
          limit={COMPACT_N}
        />
      }
      expanded={
        <RankList rows={rows} companySlug={props.companySlug} limit={8} />
      }
    />
  );
}
